const state={
	count:0,
	user:"",
	token:'',
	userlist: [],
}

export default state;



// WEBPACK FOOTER //
// ./src/store/rootState.js